import './InvoicePaymentView.scss'

import { FieldTextV6 } from '@tallink/components-lib'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { updateReferenceNumber } from '../../../../actions/actions'

export default function InvoicePaymentView() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  return (
    <div className="invoice-payment">
      <label htmlFor="invoiceReferenceNumber">{t('payment.reference.title')}</label>
      <FieldTextV6
        maxLength={30}
        name="invoiceReferenceNumber"
        onChange={e => dispatch(updateReferenceNumber(e.target.value))}
      />
    </div>
  )
}
